import { Link } from "react-router-dom";

import { PublishedNavigationElement } from "@/lib/api";

import NavigationItem from "./navigation-item";

interface NavigationPageItemProps {
  element: PublishedNavigationElement & { full_path: string };
  active: boolean;
}

export default function NavigationPageItem({ element, active }: NavigationPageItemProps) {
  return (
    <Link to={element.full_path} tabIndex={0}>
      <NavigationItem icon={element.icon ?? "file"} active={active}>
        {element.title}
      </NavigationItem>
    </Link>
  );
}
